import React from 'react';
import PropTypes from 'prop-types';

const NetballPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M27.256 9.501C23.667 3.284 15.718 1.154 9.501 4.744 3.284 8.333 1.154 16.282 4.744 22.499c3.589 6.217 11.538 8.347 17.755 4.757 6.217-3.589 8.347-11.538 4.757-17.755zm-1.405.811l.024.04c-.001.05-.004.106-.004.155-1.096-.98-5.742-4.508-12.666-5.533 4.808-1.22 10.04.825 12.646 5.338zm-14.654-4.62c2.64.285 10.241 1.837 14.565 6.114a11.61 11.61 0 0 1-1.229 3.878c-1.242-1.098-7.006-5.764-17.941-6.082a11.347 11.347 0 0 1 3.72-3.453c.291-.168.589-.315.885-.457zM6.029 10.53c2.667.049 11.913.832 18.077 5.891-.812 1.278-1.976 2.5-3.61 3.517-6.063-4.147-13.459-4.757-15.842-4.705.11-1.643.58-3.253 1.375-4.703zm6.99 16.447a11.347 11.347 0 0 1-4.143-2.111c.003-.021.009-.045.01-.07-.367-2.74.712-6.208 1.37-7.804 1.455.312 2.792.708 3.983 1.123-.688 2.384-1.363 6.958-1.22 8.862zm-8.39-10.622c1.549.014 3.04.168 4.44.41-.921 2.022-1.401 5.15-1.419 6.954a11.368 11.368 0 0 1-1.498-2.034 11.304 11.304 0 0 1-1.522-5.33zm9.494 10.862c-.189-2.035.815-6.94 1.214-8.696 2.126.828 3.624 1.655 4.213 1.997.048.992-.059 4.502-.534 6.449-1.619.45-3.29.52-4.893.25zm6.426-3.003c.113-1.163.2-2.419.132-3.172.903-.374 5.637-2.76 5.917-9.164.79 2.02.963 4.17.582 6.21-.6 1.265-1.72 3.113-3.524 4.317-1.719 1.146-2.638 1.616-3.107 1.809zm-.113 1.072c-.056.505-.108.943-.14 1.246a11.317 11.317 0 0 0 5.586-4.895 10.594 10.594 0 0 1-1.973 1.67 34.5 34.5 0 0 1-3.473 1.979z"
    />
  );
};

NetballPath.propTypes = {
  fill: PropTypes.string,
};

export default NetballPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/netball.jsx